import React from 'react'

import { t } from '@/i18n'
import { DropButton } from '@/components'
import { useApp } from '@/hooks'
import { IMenu, TLang } from '@/types'

import icEn from '@/assets/icons/ic_lang_en.png'
import icHe from '@/assets/icons/ic_lang_he.png'

const menus: IMenu[] = [
  {
    id: 'lang-en',
    name: 'lang_en',
    image: icEn,
    path: 'en',
  },
  {
    id: 'lang-he',
    name: 'lang_he',
    image: icHe,
    path: 'he',
  },
]

const LanguageSelector: React.FC = () => {
  const { language, changeLang } = useApp()

  return (
    <div className="btn-box">
      <DropButton
        menus={menus}
        buttonText={t(`lang_${language}`)}
        buttonClassName="main-btn blank"
        leftIcon={<span className="icon-globe"></span>}
        onClickLink={(lang: string) => changeLang(lang as TLang)}
      />
    </div>
  )
}

export default LanguageSelector
